import { render } from "./PayoutItem.vue?vue&type=template&id=45c2fdda"
import script from "./PayoutItem.vue?vue&type=script&lang=js"
export * from "./PayoutItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__